import { render, staticRenderFns } from "./search-group.vue?vue&type=template&id=1355333c&scoped=true"
import script from "./search-group.vue?vue&type=script&lang=js"
export * from "./search-group.vue?vue&type=script&lang=js"
import style0 from "./search-group.vue?vue&type=style&index=0&id=1355333c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355333c",
  null
  
)

export default component.exports